import { useEffect, useRef } from "react";
import { BFCACHE_RESTORE_EVENT } from "./lifecycle.ts";

/**
 * Subscribe to "restored from background" (bfcache or visibility visible).
 * Call the callback to refetch data without full page reload — only this component re-renders.
 */
export function useOnRestoreFromBackground(callback: () => void): void {
  const ref = useRef(callback);
  ref.current = callback;

  useEffect(() => {
    const handler = () => {
      ref.current();
    };
    window.addEventListener(BFCACHE_RESTORE_EVENT, handler);
    return () => window.removeEventListener(BFCACHE_RESTORE_EVENT, handler);
  }, []);
}
